// src/components/BackgroundImage.jsx
import React from 'react';
import exampleImage from '../assets/enrobé.jpeg'; 
import '../BackgroundImage.css'; 

const BackgroundImage = () => {
  return (
    <section className="container-services">
    <div className="background-image-container">
      <img 
        src={exampleImage} 
        alt="Description de l'image d'enrobé" 
        className="background-image" 
      />
      <div className="overlay-text">
        <h3>Notre engagement</h3>
        <h2>Mettre notre savoir-faire</h2>
        <p>
          au service de la création d'infrastructures durables et de haute qualité,<br />
          tout en assurant la satisfaction de nos clients.
        </p>
      </div>
    </div>
    </section>
  );
};

export default BackgroundImage;
